<printheaderview [hasimage]="1"></printheaderview>
<div class="row" *ngFor="let l of CurrentBillItemsByChargeEntryCodeController">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-11 text-align-center">
            <label class="font-familyhead">IP Bill</label>
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px">
            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient Name:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{l.PatientName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.PatientCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Referred By:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.ReferenceNo}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Bill Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.ReceiptDate | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Bill No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.BillNo}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Branch}}</label>
                </div>
              </div>

            </div>
          </div>
        </div>


        <div class="col-print-12">
          <div class="row margin-left-0px">

            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead">Admission Details</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Admission ID:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Admission Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Ward / Room:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Treating Doctor:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Admission Reason:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
            </div>

            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px">
                <div class="col-print-12">
                  <label class="margin-bottom-0px font-familysubhead">Discharge Details</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Discharge Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Approved By:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">TPA / Card No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                </div>
              </div>


            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-bold">Bill Summary:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-8">
          <div class="row margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero width-50-new">
                    <tr>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Total Billed Amount
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Tax
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Discount
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Net Payments
                      </th>

                    </tr>
                    <tr>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>

                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-6">
              <div class="row margin-left-0px">
                <div class="col-print-2">
                  <label class="margin-bottom-0px font-family font-weight-normal">Due:</label>
                </div>
                <div class="col-print-3">
                  <label class="margin-bottom-0px font-family font-weight-bold">Nill</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">Advance:</label>
            </div>
          </div>
        </div>
        <div class="col-print-8">
          <div class="row margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero width-50-new">
                    <tr>
                      <th class="font-weight-normal td-padding-tb background-primary width-80px padding-top-2px padding-bottom-2px font-family">
                        S.No
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Date
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Description
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Amount
                      </th>
                    </tr>
                    <tr>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-bold">TPA Details</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal">TPA Balance:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">0.00</label>
            </div>
          </div>
        </div>
        
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-bold">Payment:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-11">
          <div class="row margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero width-50-new">

                    <tr>
                     

                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Rec.No & Date
                      </th>

                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Pay Mode
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Charges
                      </th>
                      <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                        Amount
                      </th>
                    </tr>

                    <tr>
                      
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">HL2-HL-REC17005423 & 28-Oct-2019</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">Cash</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">2,500.00</td>
                      <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">2,500.00</td>
                    </tr>


                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <label class="margin-bottom-0px font-family font-weight-bold padding-right-10px">Total amount in words:</label>
            <label class="margin-bottom-0px font-family float-left font-weight-normal">(Rupees Two Thousand Only)</label>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<printopbillfooterview></printopbillfooterview>


